/**
 * The MoneyMind section's own vocabulary, mapped onto the panel-wide design
 * tokens in component/common/designSystem/theme.js — the same split
 * moodTheme.js, selfAssessmentTheme.js and homeTestingTheme.js use: only domain
 * meaning lives here, palettes belong to the design system.
 */
import { CHART_COLORS } from '../../../../component/common/designSystem';

/**
 * Keep it → maybe → let it go → anything else.
 *
 * Deliberately NOT a traffic light. There is no right answer to this question:
 * "Can't live without it" is not a failure and "Let it go" is not a win. It is
 * somebody sorting their own spending, and colouring one end of that red would
 * turn a private reflection into a scored one on their employer's screen. So
 * the ramp is a neutral cool sequence that reads as an ordered scale and
 * nothing more, with grey for the off-vocabulary bucket.
 */
export const TAG_RAMP = [
  CHART_COLORS.moss,
  CHART_COLORS.blue,
  CHART_COLORS.teal,
  CHART_COLORS.gray
];

/**
 * How soon after spending the entry was written. This one is mildly
 * directional — logging in the moment is what the feature is for — so it fades
 * from a positive hue rather than escalating to an alarming one.
 */
export const LAG_RAMP = [
  CHART_COLORS.green,
  CHART_COLORS.teal,
  CHART_COLORS.brandSoft,
  CHART_COLORS.gray
];

/** How many things one person has logged — sparse to prolific. */
export const VOLUME_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.brandSoft,
  CHART_COLORS.brand,
  CHART_COLORS.green
];
